<template>
  <div class="edit-barrier-info">
    <v-form ref="formEditBarrier" v-model="valid" lazy-validation>
      <v-row>
        <v-col cols="12" md="5">
          <div class="edit-barrier-info__section">
            <h2 class="edit-barrier-info__section-title">
              <v-icon left small>mdi-cube-outline</v-icon>
              Данные об объекте
            </h2>
            <v-row class="edit-barrier-info__form-row">
            <v-col cols="12" class="edit-barrier-info__col">
              <v-menu
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                disabled
                min-width="190px"
              >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="installationDateTime"
                  label="Дата установки"
                  outlined
                  dense
                  hide-details
                  disabled
                  v-on="on"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                />
              </template>
              <v-date-picker v-model="formBarrier.dateBarrier" />
              </v-menu>
            </v-col>
            <v-col cols="12" class="edit-barrier-info__col">
              <v-autocomplete
                label="Направление движения"
                :items="entryRemoteControls"
                item-text="text"
                item-value="value"
                v-model="formBarrier.entryRemoteControl"
                :rules="rules.required"
                prepend-inner-icon="mdi-arrow-decision-outline"
                outlined
                dense
                hide-details
                clearable
              />
            </v-col>
            <v-col cols="12" class="edit-barrier-info__col">
              <v-autocomplete
                label="Тип открытия"
                :items="filteredOpeningTypes"
                item-text="text"
                item-value="value"
                v-model="formBarrier.openingType"
                :rules="rules.requiredArray"
                prepend-inner-icon="mdi-lock-open"
                outlined
                dense
                hide-details
                multiple
                :menu-props="{ closeOnContentClick: false }"
                clearable
              >
                <template v-slot:selection="{ index }">
                  <span v-if="index === 0" class="text-caption grey--text text--darken-1">
                    Выбрано: {{ selectedOpeningTypes.length }}
                  </span>
                </template>
              </v-autocomplete>
              <div v-if="selectedOpeningTypesText" class="edit-barrier-info__opening-summary">
                {{ selectedOpeningTypesText }}
              </div>
            </v-col>
            <v-col cols="12" class="edit-barrier-info__col">
              <v-autocomplete
                label="Открытие по пультам"
                :items="directionMovements"
                item-text="text"
                item-value="value"
                v-model="formBarrier.directionMovement"
                prepend-inner-icon="mdi-remote"
                outlined
                dense
                hide-details
              />
            </v-col>
            </v-row>
          </div>
          <div class="edit-barrier-info__section">
            <h2 class="edit-barrier-info__section-title">
              <v-icon left small>mdi-account-outline</v-icon>
              Данные о клиенте
            </h2>
            <v-row class="edit-barrier-info__form-row">
            <v-col cols="12" class="edit-barrier-info__col">
              <v-combobox
                v-model="formBarrier.address"
                @keyup="startTypingTimer"
                @input="updateAddressSearch"
                ref="addressInput"
                prepend-inner-icon="mdi-rename-box-outline"
                :rules="rules.universal"
                :items="isFirstLoading ? [formBarrier.address] : addresses"
                item-text="addresses"
                return-object
                label="Адрес"
                outlined
                dense
                hide-details
              />
            </v-col>
            <v-col cols="12" class="edit-barrier-info__col">
              <v-autocomplete
                label="Район (только для г. Саранск)"
                v-model="formBarrier.region"
                :items="district"
                :item-text="item => (item.name) + ' (' + displayCity(item.city_id) + ')'"
                item-value="id"
                prepend-inner-icon="mdi-map-marker-radius-outline"
                outlined
                dense
                hide-details
                :disabled="!isDistrict"
              />
            </v-col>
            <v-col cols="12" class="edit-barrier-info__col">
              <v-text-field
                label="Название в моб. приложении"
                v-model="formBarrier.name"
                :rules="rules.required"
                prepend-inner-icon="mdi-rename-outline"
                outlined
                dense
                hide-details
              />
            </v-col>
            <v-col cols="12" class="edit-barrier-info__col">
              <v-autocomplete
                label="Управляющая компания"
                :items="managementCompanies"
                v-model="formBarrier.managementCompany"
                @change="setGroupManagement"
                item-text="name"
                prepend-inner-icon="mdi-home-account"
                item-value="id"
                outlined
                dense
                hide-details
                clearable
              />
            </v-col>
            <v-col cols="12" class="edit-barrier-info__col">
              <v-text-field
                label="Компания-собственник"
                v-model="formBarrier.groupManagement"
                prepend-inner-icon="mdi-shield-account"
                outlined
                dense
                hide-details
                disabled
              />
            </v-col>
            <v-col cols="12" class="edit-barrier-info__col">
              <v-autocomplete
                label="Тип договора на обслуживание"
                :items="contractTypes"
                v-model="formBarrier.contractType"
                prepend-inner-icon="mdi-file-document-edit-outline"
                item-text="text"
                item-value="value"
                outlined
                dense
                hide-details
                clearable
              />
            </v-col>
            <v-col cols="12" class="edit-barrier-info__col">
              <v-text-field
                label="Комментарий"
                v-model="formBarrier.comment"
                prepend-inner-icon="mdi-comment-outline"
                outlined
                dense
                hide-details
                clearable
              />
            </v-col>
            <v-col cols="12" class="edit-barrier-info__col">
              <v-textarea
                label="Технический комментарий"
                v-model="formBarrier.technicalComment"
                prepend-inner-icon="mdi-tools"
                outlined
                dense
                hide-details
                auto-grow
                rows="2"
                placeholder="IP, версия прошивки, заметки по настройке"
                :disabled="!isTechnicalCommentEditable"
              />
            </v-col>
            <v-col cols="12" class="edit-barrier-info__col" v-if="showBarrierOpenPhone">
              <v-text-field
                label="Номер телефона для звонка на устройство"
                v-model="formBarrier.barrierOpenPhone"
                prepend-inner-icon="mdi-phone"
                outlined
                dense
                hide-details
              />
            </v-col>
            <v-col cols="12" class="edit-barrier-info__col" v-if="formBarrier.physicalStatus !== 5">
              <v-autocomplete
                label="Физический статус"
                prepend-inner-icon="mdi-progress-clock"
                :items="physicalStatus"
                v-model="formBarrier.physicalStatus"
                :rules="rules.required"
                item-text="status"
                item-value="id"
                outlined
                dense
                hide-details
              />
            </v-col>
            <v-col cols="12" class="edit-barrier-info__col" v-if="formBarrier.physicalStatus === 5">
              <v-text-field
                label="Физический статус"
                v-model="physicalStatusOldBarrier"
                prepend-inner-icon="mdi-progress-clock"
                disabled
                outlined
                dense
                hide-details
              />
            </v-col>
            <v-col cols="12" class="edit-barrier-info__col" v-if="!barrierEdit.barrier.device_id">
              <v-autocomplete
                label="Плательщик"
                :items="payers"
                v-model="formBarrier.payer"
                prepend-inner-icon="mdi-account-card-outline"
                item-text="text"
                item-value="text"
                outlined
                dense
                hide-details
              />
            </v-col>
            </v-row>
          </div>
          <div class="edit-barrier-info__section">
            <h2 class="edit-barrier-info__section-title">
              <v-icon left small>mdi-chip</v-icon>
              Данные о физическом устройстве
            </h2>
            <v-row class="edit-barrier-info__form-row">
            <v-col cols="12" class="edit-barrier-info__col">
              <v-autocomplete
                label="Модель шлагбаума"
                :items="barrierModels"
                v-model="formBarrier.modelBarrier"
                prepend-inner-icon="mdi-globe-model"
                item-text="text"
                item-value="value"
                outlined
                dense
                hide-details
                clearable
              />
            </v-col>
            <v-col cols="12" class="edit-barrier-info__col">
              <v-autocomplete
                label="Тип модуля GSM"
                :items="gsmModuleTypes"
                v-model="formBarrier.gsmModuleType"
                prepend-inner-icon="mdi-cellphone-wireless"
                item-text="text"
                item-value="value"
                outlined
                dense
                hide-details
                clearable
              />
            </v-col>
            <v-col cols="12" class="edit-barrier-info__col">
              <v-autocomplete
                label="Тип пультов"
                :items="remoteControlTypes"
                v-model="formBarrier.remotes"
                prepend-inner-icon="mdi-remote"
                item-text="text"
                item-value="value"
                outlined
                dense
                hide-details
                clearable
              />
            </v-col>
            <v-col cols="12" class="edit-barrier-info__col">
              <v-autocomplete
                label="Магнитная петля"
                :items="magneticLoopTypes"
                v-model="formBarrier.magneticLoop"
                prepend-inner-icon="mdi-magnet"
                item-text="text"
                item-value="value"
                outlined
                dense
                hide-details
                clearable
              />
            </v-col>
            <v-col cols="12" class="edit-barrier-info__col">
              <v-autocomplete
                label="GSM модуль"
                :items="freeGsmDevices"
                v-model="formBarrier.gsmModuleDeviceId"
                prepend-inner-icon="mdi-cellphone-link"
                item-text="displayText"
                item-value="id"
                outlined
                dense
                hide-details
                clearable
              />
            </v-col>
            <v-col v-if="roleName === 'admin'" cols="12" class="edit-barrier-info__col">
              <v-checkbox
                v-model="formBarrier.hidder"
                label="Отображение в приложении"
                hide-details
                dense
                color="primary"
              />
            </v-col>
            <v-col v-if="isBewardBarrier" cols="12" class="edit-barrier-info__col">
              <v-checkbox
                v-model="formBarrier.forbidGuestAccess"
                label="Запретить добавление гостевого доступа по ГРЗ"
                hide-details
                dense
                color="primary"
              />
            </v-col>
            <v-col v-if="isBewardBarrier" cols="12" class="edit-barrier-info__col">
              <v-checkbox
                v-model="formBarrier.forbidClientAddCarNumbers"
                label="Запретить клиентам добавлять номера автомобиля (только УК может добавлять)"
                hide-details
                dense
                color="primary"
              />
            </v-col>
            <v-col cols="12" class="edit-barrier-info__col">
              <BindingDoorphone />
            </v-col>
            </v-row>
          </div>
        </v-col>

        <v-col cols="12" md="7">
          <div class="edit-barrier-info__current-device">
            <v-icon left color="success">mdi-check-circle-outline</v-icon>
            <span v-if="currentDevice">{{ currentDevice }}</span>
            <span v-else-if="!barrierEdit.barrier.device_id">Старый шлагбаум (устройство старого образца)</span>
          </div>

          <div class="edit-barrier-info__card mt-3" :class="{ 'edit-barrier-info__card--disabled': !barrierEdit.barrier.device_id }">
            <div class="edit-barrier-info__filters">
              <div class="edit-barrier-info__filters-title">
                <v-icon left small>mdi-devices</v-icon>
                Устройства
              </div>
              <div class="edit-barrier-info__filters-row">
                <v-text-field
                  v-model="searchDevice"
                  label="Поиск по IP-адресу"
                  outlined
                  dense
                  hide-details
                  class="edit-barrier-info__field"
                  autocomplete="off"
                  @keyup="(e) => e.keyCode === 13 && filterDevices()"
                />
                <v-btn
                  color="primary"
                  class="text-none edit-barrier-info__search-btn"
                  dark
                  rounded
                  @click.prevent="filterDevices"
                >
                  <v-icon left>mdi-magnify</v-icon>
                  Поиск
                </v-btn>
              </div>
            </div>
            <v-data-table
              class="edit-barrier-info__table"
              v-model="selectedDevices"
              :options.sync="universalOptions"
              :server-items-length="universalTotalDevices"
              :headers="headersDevicesEdit"
              :items="getItemsDevices"
              item-key="id"
              show-select
              :footer-props="{ 'items-per-page-options': [10, 20, 50, 100] }"
              :single-select="true"
              :disable-sort="true"
            />
            <div class="edit-barrier-info__table-actions">
              <v-btn
                v-if="$checkPermission('edit_barrier')"
                :disabled="!selectedDevices.length"
                color="success"
                class="text-none"
                dark
                rounded
                @click="validate"
              >
                <v-icon left>mdi-swap-horizontal</v-icon>
                Сменить устройство
              </v-btn>
            </div>
          </div>

          <div v-if="barrierEdit.barrier.device_id" class="edit-barrier-info__section mt-4">
            <h2 class="edit-barrier-info__section-title">Изображение с устройства</h2>
            <v-img
              :src="barrierEdit.barrier.snapshot"
              max-width="400"
              contain
              class="edit-barrier-info__image"
              @click.stop="dialogImage = true"
              alt="Изображение отсутствует"
            />
            <v-dialog v-model="dialogImage" :max-width="isMobile ? '90%' : '50%'" content-class="dialog-border-radius">
              <v-img :src="barrierEdit.barrier.snapshot" max-width="100%" alt="" />
            </v-dialog>
          </div>
        </v-col>
      </v-row>

      <v-divider class="my-4" />

      <div class="edit-barrier-info__actions">
        <div class="edit-barrier-info__actions-left">
          <v-btn
            color="primary"
            class="text-none"
            rounded
            @click="validate()"
          >
            <v-icon left>mdi-content-save-outline</v-icon>
            Сохранить
          </v-btn>
          <v-btn
            color="primary"
            outlined
            class="text-none"
            rounded
            @click.prevent="returnBarrier"
          >
            <v-icon left>mdi-close</v-icon>
            Отменить
          </v-btn>
        </div>
        <v-btn
          color="error"
          outlined
          class="text-none"
          rounded
          @click.stop="dialogWarning = true"
        >
          <v-icon left>mdi-delete-outline</v-icon>
          {{ displayLabelNameRemove }}
        </v-btn>
      </div>

      <v-dialog v-model="dialogWarning" width="500" content-class="dialog-border-radius" persistent>
        <BaseDeleteModal
          :active.sync="dialogWarning"
          @close="dialogWarning = false"
          @submit="remove()"
          :messageTitle="displayLabelNameRemove"
          messageText="Подтверждая, вы удалите объект."
          confirmText="Удалить"
          cancelText="Отмена"
          confirmColor="error"
        />
      </v-dialog>
    </v-form>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import {
  entryRemoteControls,
  openingTypes,
  accessAreas,
  directionMovements,
  rules,
  headersDevicesEdit,
  physicalStatus,
  payers, ENUM_LABELS,
} from '../../consts';
import watchTableOptions from '../../../../mixins/watchTableOptions';
import BaseDeleteModal from '../../../BaseDeleteModal';
import BindingDoorphone from '@/components/barrier/EditBarrier/components/BindingDoorphone';

export default {
  name: 'GeneralInfo',
  components: { BaseDeleteModal, BindingDoorphone },
  mixins: [watchTableOptions],
  props: ['returnBarrier'],
  data: () => {
    return {
      isFirstLoading: true,
      rules,
      payers,
      entryRemoteControls,
      openingTypes,
      accessAreas,
      directionMovements,
      physicalStatus,
      dialog: false,
      physicalStatusOldBarrier: 'Старый шлагбаум',
      universalOptions: {
        itemsPerPage: 10,
        page: 1,
        sortBy: [],
        sortDesc: [],
      },
      universalTotalDevices: 0,
      selectedDevices: [],
      managementCompanies: [],
      dialogWarning: false,
      headersDevicesEdit,
      dialogImage: false,
      isDistrict: false,
      valid: true,
      searchDevice: '',
      currentDevice: '',
      searchAddress: '',
      typingTimer: null,
      formBarrier: {
        address: {
          addresses: '',
        },
        region: null,
        hidder: false,
        directionMovement: '',
        managementCompany: null,
        entryRemoteControl: '',
        physicalStatus: '',
        openingType: [],
        dateBarrier: '',
        groupManagement: '',
        deviceId: null,
        barrierOpenPhone: '',
        payer: '',
        modelBarrier: '',
        gsmModuleType: '',
        remotes: '',
        magneticLoop: '',
        contractType: '',
        comment: '',
        technicalComment: '',
        gsmModuleDeviceId: null,
        forbidGuestAccess: false,
        forbidClientAddCarNumbers: false,
      },
      freeGsmDevices: [],
      barrierModels: Object.entries(ENUM_LABELS.model_barrier).map(([key, value]) => ({
        text: value,
        value: key,
      })),
      gsmModuleTypes: Object.entries(ENUM_LABELS.gsm_module_type).map(([key, value]) => ({
        text: value,
        value: key,
      })),
      remoteControlTypes: Object.entries(ENUM_LABELS.remotes).map(([key, value]) => ({
        text: value,
        value: key,
      })),
      magneticLoopTypes: Object.entries(ENUM_LABELS.magnetic_loop).map(([key, value]) => ({
        text: value,
        value: key,
      })),
      contractTypes: Object.entries(ENUM_LABELS.contract_type).map(([key, value]) => ({
        text: value,
        value: key,
      })),
      isMobile: false,
    };
  },
  computed: {
    ...mapGetters({
      district: 'Doorphone/districts',
      barrierEdit: 'Barriers/barrierEdit',
      addresses: 'Doorphone/addresses',
      devices: 'Device/devices',
      roleName: 'roleName',
    }),
    filteredOpeningTypes () {
      if (this.barrierEdit.barrier.physical_status === 5) {
        return this.openingTypes.filter(item => ['C', 'RC'].includes(item.value));
      }
      return this.openingTypes;
    },
    selectedOpeningTypes () {
      if (!this.formBarrier.openingType) return [];
      return Array.isArray(this.formBarrier.openingType) ? this.formBarrier.openingType : [this.formBarrier.openingType];
    },
    selectedOpeningTypesText () {
      if (!this.selectedOpeningTypes.length) return '';
      return this.selectedOpeningTypes
        .map(type => (this.openingTypes.find(item => item.value === type) || {}).text)
        .filter(Boolean)
        .join(', ');
    },
    showBarrierOpenPhone () {
      return this.selectedOpeningTypes.includes('C');
    },
    getItemsDevices () {
      return this.devices.filter(device => device.id !== this.formBarrier.deviceId);
    },
    displayLabelName () {
      if (this.barrierEdit.barrier.passage_type === 'G') {
        return 'ворот';
      } else {
        return 'шлагбаума';
      }
    },
    displayLabelNameRemove () {
      if (this.barrierEdit.barrier.passage_type === 'G') {
        return 'Удалить ворота';
      } else {
        return 'Удалить шлагбаум';
      }
    },
    installationDateTime () {
      if (this.formBarrier.dateBarrier) {
        const date = new Date(this.formBarrier.dateBarrier);
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return date.toLocaleDateString('ru-RU', options);
      } else {
        return '';
      }
    },
    isBewardBarrier () {
      return this.barrierEdit?.barrier?.manufacturer === 'Beward';
    },
    isTechnicalCommentEditable () {
      return ['admin', 'admin-engineer'].includes(this.roleName);
    },
  },
  mounted () {
    if (window.innerWidth < 600) {
      this.isMobile = true;
    }
  },
  watch: {
    universalOptions (curr, prev) {
      this.handleOptionsChange(curr, prev, () => {
        this.universalChangePage();
      });
    },
  },
  created () {
    this.initializeBarrierData();
    this.initializeManagementCompany();
    this.loadAvailableDevices();
    this.loadFreeGsmDevices();

    setTimeout(() => this.$nextTick(() => {
      this.isFirstLoading = false;
    }));
  },
  methods: {
    ...mapActions({
      loadDevices: 'Device/getDevices',
      getAddressSearch: 'Doorphone/getAddressSearch',
      removeBarrier: 'Barriers/removeBarrier',
      updateBarrier: 'Barriers/updateBarrier',
    }),
    normalizeOpeningType (value) {
      if (!value) return [];
      if (Array.isArray(value)) return value.filter(Boolean);
      if (typeof value === 'string') {
        if (value === 'CG') return ['C', 'G'];
        return value.split(',').map(v => v.trim()).filter(Boolean);
      }
      return [];
    },
    initializeBarrierData () {
      const barrier = this.barrierEdit?.barrier || {};
      this.currentDevice = barrier.ip_address ? `Текущее устройство: ${barrier.ip_address}` : '';
      this.addresses[0] = barrier.address || '';
      this.formBarrier.address.addresses = barrier.address || '';
      this.formBarrier.dateBarrier = barrier.installed_at || '';
      this.formBarrier.physicalStatus = barrier.physical_status || null;
      this.formBarrier.openingType = this.normalizeOpeningType(barrier.opening_type);
      this.formBarrier.deviceId = barrier.device_id || null;
      this.formBarrier.hidder = barrier.display_in_app || false;
      this.formBarrier.entryRemoteControl = barrier.direction ? barrier.direction.toString() : '';

      this.formBarrier.directionMovement = barrier.remote_control ? '1' : '2';

      this.formBarrier.barrierOpenPhone = barrier.barrier_open_phone || '';
      this.formBarrier.payer = barrier.payer || '';
      this.formBarrier.modelBarrier = barrier.model_barrier || '';
      this.formBarrier.gsmModuleType = barrier.gsm_module_type || '';
      this.formBarrier.remotes = barrier.remotes || '';
      this.formBarrier.magneticLoop = barrier.magnetic_loop || '';
      this.formBarrier.contractType = barrier.contract_type || '';
      this.formBarrier.comment = barrier.comment || '';
      this.formBarrier.technicalComment = barrier.technical_comment || '';
      this.formBarrier.name = barrier.name || '';
      this.formBarrier.forbidGuestAccess = barrier.forbid_guest_access ?? false;
      this.formBarrier.forbidClientAddCarNumbers = barrier.forbid_client_add_car_numbers ?? false;
      // gsmModuleDeviceId будет установлен в loadFreeGsmDevices после загрузки списка

      this.managementCompanies = this.barrierEdit?.management_companies || [];
    },

    initializeManagementCompany () {
      const barrier = this.barrierEdit?.barrier || {};
      const companyId = barrier.management_company_id;

      if (companyId) {
        this.formBarrier.managementCompany = companyId;
        const foundCompany = this.managementCompanies.find(company => company.id === companyId);
        this.formBarrier.groupManagement = foundCompany ? foundCompany.group_name : 'Нет компании';
      }
    },
    loadAvailableDevices () {
      const barrier = this.barrierEdit?.barrier || {};

      const filters = {
        free: 1,
        agent_id: barrier.agent_id || null,
        'model.name': barrier.model || '',
      };

      this.loadDevices({
        filters,
        pagination: 1,
        limit: this.universalOptions.itemsPerPage,
      })
        .then(response => {
          this.universalTotalDevices = response.meta?.total || 0;
        })
        .catch(error => {
          console.error(error);
          this.$flash_warning('Ошибка при загрузке устройств');
        });
    },
    updateAddressSearch () {
      const val = this.formBarrier.address;
      if (val && this.isDistrict) {
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(() => {
          if (!this.isFirstLoading && val) {
            this.getAddressSearch({
              value: val,
            })
              .then((res) => {
                this.formBarrier.region = null;
                this.isDistrict = !!res.districts[0];
              });
          }
        }, 600);
      }
    },
    startTypingTimer (val) {
      clearTimeout(this.typingTimer);
      this.typingTimer = setTimeout(() => {
        if (!this.isFirstLoading && val.srcElement._value) {
          this.getAddressSearch({
            value: val.srcElement._value,
          })
            .then((res) => {
              this.formBarrier.region = null;
              this.isDistrict = !!res.districts[0];
            });
        }
      }, 600);
    },
    setGroupManagement (groupCompanyId) {
      const company = this.managementCompanies.find(item => item?.id === groupCompanyId);
      if ((company) && (company.group_name)) {
        this.formBarrier.groupManagement = company.group_name;
      } else {
        this.formBarrier.groupManagement = '';
      }
    },
    displayCity (item) {
      switch (item) {
        case 1: return 'Ульяновск';
        case 2: return 'Саранск';
        default: return '';
      }
    },
    filterDevices () {
      this.universalOptions.page = 1;
      this.universalChangePage();
    },
    universalChangePage () {
      const filters = ({
        free: 1,
        agent_id: this.barrierEdit.barrier.agent_id,
        'model.name': this.barrierEdit.barrier.model,
      });

      if (this.searchDevice) {
        filters.ip_address = this.searchDevice;
      }

      this.loadDevices({
        pagination: 1,
        limit: this.universalOptions.itemsPerPage,
        page: this.universalOptions.page,
        filters,
      })
        .then((response) => {
          this.universalTotalDevices = response.meta.total;
        });
    },
    formatGsmDeviceDisplayText (device) {
      const parts = [];

      if (device.gsm_phone) {
        const phoneDigits = device.gsm_phone.replace(/\D/g, '');
        const displayPhone = phoneDigits.length === 10 ? '7' + phoneDigits : device.gsm_phone;
        parts.push(displayPhone);
      }

      if (device.city_phone_number?.phone_number) {
        parts.push(`(${device.city_phone_number.phone_number})`);
      }

      if (device.model) {
        parts.push(`- ${device.model}`);
      }

      if (device.manufacturer) {
        parts.push(`(${device.manufacturer})`);
      }

      return parts.join(' ');
    },
    loadFreeGsmDevices () {
      this.loadDevices({
        filters: {
          type: 'G',
          free: 1,
        },
        pagination: 0,
      })
        .then((response) => {
          this.freeGsmDevices = (response.devices || []).map(device => ({
            id: device.id,
            displayText: this.formatGsmDeviceDisplayText(device),
          }));
          const barrier = this.barrierEdit?.barrier || {};
          const gsmModuleId = barrier.gsm_module_device_id;

          if (barrier.gsm_module) {
            const currentGsm = barrier.gsm_module;
            const exists = this.freeGsmDevices.find(d => d.id === currentGsm.id);
            if (!exists) {
              this.freeGsmDevices.push({
                id: currentGsm.id,
                displayText: this.formatGsmDeviceDisplayText(currentGsm),
              });
            }
          } else if (gsmModuleId) {
            const exists = this.freeGsmDevices.find(d => d.id === gsmModuleId);
            if (!exists) {
              this.loadDevices({
                filters: {
                  type: 'G',
                },
                pagination: 0,
              })
                .then((allDevicesResponse) => {
                  const device = (allDevicesResponse.devices || []).find(d => d.id === gsmModuleId);
                  if (device) {
                    this.freeGsmDevices.push({
                      id: device.id,
                      displayText: this.formatGsmDeviceDisplayText(device),
                    });
                  }
                  this.$nextTick(() => {
                    this.formBarrier.gsmModuleDeviceId = gsmModuleId;
                  });
                })
                .catch(() => {
                  this.$nextTick(() => {
                    this.formBarrier.gsmModuleDeviceId = gsmModuleId;
                  });
                });
              return;
            }
          }

          if (gsmModuleId) {
            this.$nextTick(() => {
              this.formBarrier.gsmModuleDeviceId = gsmModuleId;
            });
          }
        })
        .catch((error) => {
          console.error(error);
          this.$flash_warning('Ошибка при загрузке GSM модулей');
        });
    },
    remove () {
      this.removeBarrier({ id: this.$route.params.id })
        .then(() => {
          this.$router.push({ name: 'Barriers' });
          this.$flash_success('Изменения сохранены!');
        })
        .catch(() => {
          this.$flash_warning('Ошибка при удалении');
        });
    },
    async validate () {
      await this.$refs.addressInput.blur();
      const tempDevice = await this.prepareDevice();

      if (this.$refs.formEditBarrier.validate()) {
        const tempBarrier = this.prepareTempBarrier(tempDevice);
        if (this.formBarrier.region === null && this.isDistrict) {
          this.$flash_danger('Заполните поле "Район"');
        } else {
          await this.validateAndSubmit(tempBarrier);
        }
      } else {
        this.$flash_danger('Заполните все поля');
      }
    },
    async prepareDevice () {
      let tempDevice;
      if (!this.selectedDevices.length) {
        tempDevice = this.barrierEdit.barrier.device_id;
      } else {
        tempDevice = this.selectedDevices[0].id;
      }
      return tempDevice;
    },
    prepareTempBarrier (tempDevice) {
      const tempBarrier = {
        display_in_app: this.formBarrier.hidder,
        physical_status: this.formBarrier.physicalStatus,
        opening_type: this.selectedOpeningTypes,
        direction: this.formBarrier.entryRemoteControl,
        passage_type: this.barrierEdit.barrier.passage_type,
        without_device: this.barrierEdit.barrier.without_device,
      };

      if (tempDevice) tempBarrier.device_id = tempDevice;
      if (this.formBarrier.region && this.isDistrict) tempBarrier.region_id = this.formBarrier.region;
      if (this.formBarrier.directionMovement) tempBarrier.remote_control = this.formBarrier.directionMovement === '1';
      if (this.formBarrier.name) tempBarrier.name = this.formBarrier.name;
      tempBarrier.management_company_id = this.formBarrier.managementCompany ? this.formBarrier.managementCompany : null;
      tempBarrier.comment = this.formBarrier.comment ? this.formBarrier.comment : null;
      if (this.isTechnicalCommentEditable) {
        tempBarrier.technical_comment = this.formBarrier.technicalComment ? this.formBarrier.technicalComment : null;
      }
      tempBarrier.barrier_open_phone = this.showBarrierOpenPhone && this.formBarrier.barrierOpenPhone
        ? this.formBarrier.barrierOpenPhone
        : null;
      tempBarrier.model_barrier = this.formBarrier.modelBarrier ? this.formBarrier.modelBarrier : null;
      tempBarrier.gsm_module_type = this.formBarrier.gsmModuleType ? this.formBarrier.gsmModuleType : null;
      tempBarrier.remotes = this.formBarrier.remotes ? this.formBarrier.remotes : null;
      tempBarrier.magnetic_loop = this.formBarrier.magneticLoop ? this.formBarrier.magneticLoop : null;
      tempBarrier.payer = this.formBarrier.payer ? this.formBarrier.payer : null;
      tempBarrier.contract_type = this.formBarrier.contractType ? this.formBarrier.contractType : null;
      tempBarrier.gsm_module_device_id = this.formBarrier.gsmModuleDeviceId || null;
      tempBarrier.forbid_guest_access = this.formBarrier.forbidGuestAccess;
      tempBarrier.forbid_client_add_car_numbers = this.formBarrier.forbidClientAddCarNumbers;

      tempBarrier.address = (typeof this.formBarrier.address === 'object')
        ? this.formBarrier.address.addresses
        : this.formBarrier.address;

      return tempBarrier;
    },
    async validateAndSubmit (tempBarrier) {
      try {
        await this.updateBarrier({
          id: this.$route.params.id,
          params: tempBarrier,
        });
        this.$router.push({ name: 'DetailBarrier', params: { id: this.$route.params.id } });
        this.$flash_success('Изменения успешно сохранены');
      } catch (message) {
        if (message.length > 0) {
          message.forEach(msg => {
            this.$flash_warning(msg);
            console.error(msg);
            this.$sentry_exception(msg);
          });
        } else {
          this.$flash_warning('Ошибка при изменении информации');
        }
      }
    },
  },
};

</script>

<style lang="scss" scoped>
.edit-barrier-info__section {
  margin-bottom: 0;
}

.edit-barrier-info__section-title {
  font-size: 1rem;
  font-weight: 500;
  color: #37474f;
  margin: 0 0 16px 0;
  display: flex;
  align-items: center;
}

.edit-barrier-info__form-row {
  margin: 0 -12px;
}

.edit-barrier-info__col {
  padding-top: 0;
  padding-bottom: 12px;
}

.edit-barrier-info__opening-summary {
  margin-top: 6px;
  color: rgba(0, 0, 0, 0.72);
  font-size: 0.8rem;
  line-height: 1.35;
}

.edit-barrier-info__current-device {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background: rgba(76, 175, 80, 0.08);
  border: 1px solid rgba(76, 175, 80, 0.3);
  border-radius: 12px;
  font-size: 0.9375rem;
  color: #2e7d32;
}

.edit-barrier-info__card {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 12px;
  overflow: hidden;
}

.edit-barrier-info__card--disabled {
  opacity: 0.7;
  pointer-events: none;
}

.edit-barrier-info__filters {
  padding: 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.edit-barrier-info__filters-title {
  font-size: 1rem;
  font-weight: 500;
  color: #37474f;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
}

.edit-barrier-info__filters-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.edit-barrier-info__field {
  flex: 1;
  min-width: 200px;
}

.edit-barrier-info__search-btn {
  flex-shrink: 0;
}

.edit-barrier-info__table {
  border: none;
}

.edit-barrier-info__table-actions {
  padding: 12px 16px;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}

.edit-barrier-info__image {
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
}

.edit-barrier-info__actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}

.edit-barrier-info__actions-left {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

::v-deep .dialog-border-radius {
  border-radius: 12px;
}
</style>
